/* PureWell Home — "Find Your Water System" quiz.
   Reads collection URLs from data-config on [data-pw-quiz]. No network calls.
   Recommendations are general guidance by system category, not by product. */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-pw-quiz]');
  if (!roots.length) return;

  var QUESTIONS = [
    {
      id: 'source', type: 'one',
      title: 'Where does your home get its water?',
      help: 'A private well has its own pump and pressure tank. A city or utility supply comes with a monthly water bill.',
      options: [
        { v: 'city', t: 'City or utility water' },
        { v: 'well', t: 'Private well' },
        { v: 'unsure', t: 'I am not sure', s: 'We will point you to a test first' }
      ]
    },
    {
      id: 'concerns', type: 'many',
      title: 'What would you like to fix?',
      help: 'Choose everything that applies.',
      options: [
        { v: 'taste', t: 'Chlorine taste or smell', only: ['city', 'unsure'] },
        { v: 'hard', t: 'Scale, spots or dry skin', s: 'Common signs of hard water' },
        { v: 'iron', t: 'Orange or rust-colored stains', only: ['well', 'unsure'] },
        { v: 'sulfur', t: 'Rotten-egg smell', only: ['well', 'unsure'] },
        { v: 'sediment', t: 'Cloudy, gritty or sandy water' },
        { v: 'contam', t: 'Lead, PFAS or other contaminants' },
        { v: 'microbes', t: 'Bacteria or microbial safety', only: ['well', 'unsure'] }
      ]
    },
    {
      id: 'hardness', type: 'one',
      title: 'Do you know how hard your water is?',
      help: 'Hardness is measured in grains per gallon (gpg). Your utility report or a test kit will show it.',
      options: [
        { v: 'unknown', t: 'I do not know' },
        { v: 'soft', t: 'Under 3.5 gpg', s: 'Soft' },
        { v: 'moderate', t: '3.5 to 7 gpg', s: 'Moderately hard' },
        { v: 'hard', t: '7 to 10.5 gpg', s: 'Hard' },
        { v: 'veryhard', t: 'Over 10.5 gpg', s: 'Very hard' }
      ]
    },
    {
      id: 'baths', type: 'one',
      title: 'How many bathrooms does your home have?',
      help: 'Bathrooms are a quick way to estimate how much water you use at once.',
      options: [
        { v: '1-2', t: '1 to 2 bathrooms' },
        { v: '3', t: '3 bathrooms' },
        { v: '4+', t: '4 or more bathrooms' }
      ]
    },
    {
      id: 'softener', type: 'one',
      title: 'How do you feel about salt?',
      help: 'This only changes how we describe your hard-water options.',
      when: function (a) { return needsSoftening(a); },
      options: [
        { v: 'salt', t: 'Salt-based is fine', s: 'Removes hardness minerals' },
        { v: 'saltfree', t: 'I prefer salt-free', s: 'Aims to reduce scale instead' },
        { v: 'either', t: 'Show me both' }
      ]
    },
    {
      id: 'sink', type: 'one',
      title: 'Do you also want a drinking-water filter at the kitchen sink?',
      help: 'Under-sink systems treat the tap you drink from, in addition to a whole-house system.',
      options: [
        { v: 'yes', t: 'Yes, include one' },
        { v: 'no', t: 'No, whole house only' }
      ]
    }
  ];

  var LABELS = {
    city: 'City water', well: 'Private well', unsure: 'Source unsure',
    taste: 'Chlorine taste', hard: 'Hard water signs', iron: 'Iron stains', sulfur: 'Sulfur smell',
    sediment: 'Sediment', contam: 'Contaminant concern', microbes: 'Microbial concern',
    soft: 'Soft', moderate: 'Moderately hard', hardlvl: 'Hard', veryhard: 'Very hard', unknown: 'Hardness unknown',
    '1-2': '1 to 2 baths', '3': '3 baths', '4+': '4+ baths'
  };

  function has(a, v) { return (a.concerns || []).indexOf(v) > -1; }

  function needsSoftening(a) {
    return has(a, 'hard') || ['moderate', 'hard', 'veryhard'].indexOf(a.hardness) > -1;
  }

  function recommend(a, urls) {
    var wellSignals = a.source === 'well' || (a.source === 'unsure' && (has(a, 'iron') || has(a, 'sulfur') || has(a, 'microbes')));
    var soften = needsSoftening(a);
    var filterNeed = wellSignals || has(a, 'taste') || has(a, 'sediment') || has(a, 'contam') || (!soften && !has(a, 'iron') && !has(a, 'sulfur'));
    var recs = [];
    var baths = a.baths || '1-2';

    if (wellSignals) {
      recs.push({
        main: true, title: 'Well water treatment system',
        why: (has(a, 'iron') || has(a, 'sulfur')
          ? 'Iron staining and sulfur odor are common reasons homeowners on private wells choose a dedicated well water system. '
          : 'Private wells vary from home to home, so well-focused systems are the usual starting point. ') +
          'Final sizing depends on your test results and peak flow.',
        url: urls.well, cta: 'Shop well water systems'
      });
      if (soften) {
        recs.push({
          title: 'Add water softening',
          why: softenCopy(a),
          url: a.softener === 'saltfree' ? urls.saltfree : urls.soft,
          cta: a.softener === 'saltfree' ? 'Shop salt-free conditioners' : 'Shop water softeners'
        });
      }
      if (has(a, 'microbes') || a.source === 'unsure' || a.source === 'well') {
        recs.push({
          title: 'UV purification, if a test calls for it',
          why: 'UV treatment is commonly paired with private wells when a lab test finds bacteria. Test first, then decide.',
          url: urls.well, cta: 'See well water options'
        });
      }
    } else {
      if (filterNeed && soften) {
        recs.push({
          main: true, title: 'Filter and softener combo system',
          why: 'You described both filtration needs and hard water. A combination system treats both in one purchase and one footprint.',
          url: urls.combo, cta: 'Shop combo systems'
        });
        recs.push({
          title: 'Or buy them separately',
          why: softenCopy(a),
          url: a.softener === 'saltfree' ? urls.saltfree : urls.soft,
          cta: 'Shop water softeners'
        });
      } else if (soften) {
        recs.push({
          main: true, title: a.softener === 'saltfree' ? 'Salt-free water conditioner' : 'Water softener',
          why: softenCopy(a),
          url: a.softener === 'saltfree' ? urls.saltfree : urls.soft,
          cta: a.softener === 'saltfree' ? 'Shop salt-free conditioners' : 'Shop water softeners'
        });
        if (a.softener === 'either') {
          recs.push({
            title: 'Salt-free conditioner',
            why: 'Salt-free conditioners aim to reduce scale buildup without adding salt. They do not remove hardness minerals, so they suit lighter scale problems better than very hard water.',
            url: urls.saltfree, cta: 'Shop salt-free conditioners'
          });
        }
      } else {
        recs.push({
          main: true, title: 'Whole-house water filter',
          why: 'A whole-house filter treats water where it enters your home, so every tap and shower gets it. Systems differ in what they are designed to reduce, so match the media to your concern.',
          url: urls.whole, cta: 'Shop whole-house filters'
        });
      }
    }

    if (a.sink === 'yes') {
      recs.push({
        title: 'Under-sink drinking water filter',
        why: 'Reverse osmosis and under-sink filters treat the tap you drink and cook with, and pair well with a whole-house system.',
        url: urls.sink, cta: 'Shop under-sink filtration'
      });
    }

    if (a.source === 'unsure' || a.source === 'well' || has(a, 'contam') || a.hardness === 'unknown') {
      recs.push({
        title: 'Test your water first',
        why: a.source === 'well'
          ? 'A lab test is the only reliable way to know what is in a private well. It also keeps you from paying for treatment you do not need.'
          : 'Concerns like lead, PFAS and hardness are best confirmed with a test or your utility’s latest water quality report before you buy.',
        url: urls.test, cta: 'Shop water test kits'
      });
    }

    var note = 'Sizing: with ' + (baths === '1-2' ? '1 to 2 bathrooms' : baths === '3' ? '3 bathrooms' : '4 or more bathrooms') +
      ', check each system’s rated flow rate against your home’s peak demand before you order. ' +
      'This is general guidance based on your answers, not a water analysis.';
    return { recs: recs, note: note };
  }

  function softenCopy(a) {
    if (a.softener === 'saltfree') {
      return 'Salt-free conditioners aim to reduce scale buildup without adding salt. They do not remove hardness minerals, so for very hard water a salt-based softener is the more conventional choice.';
    }
    if (a.hardness === 'veryhard' || a.hardness === 'hard') {
      return 'At ' + (a.hardness === 'veryhard' ? 'over 10.5' : '7 to 10.5') + ' gpg, a salt-based softener is the conventional way to remove hardness minerals.';
    }
    return 'A salt-based softener removes hardness minerals that cause scale on fixtures, appliances and glassware.';
  }

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else n.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }

  roots.forEach(function (root) {
    var urls = {};
    try { urls = JSON.parse(root.getAttribute('data-config') || '{}'); } catch (e) { urls = {}; }
    ['whole', 'well', 'soft', 'saltfree', 'combo', 'sink', 'test', 'contact'].forEach(function (k) { urls[k] = urls[k] || '#'; });

    var answers = {};
    var step = 0;
    var uid = 'pwq' + Math.random().toString(36).slice(2, 7);

    function visible() {
      return QUESTIONS.filter(function (q) { return !q.when || q.when(answers); });
    }

    function render(focus) {
      var qs = visible();
      root.innerHTML = '';
      var shell = el('div', { class: 'pw-quiz' });

      if (step >= qs.length) { renderResult(shell); root.appendChild(shell); return; }

      var q = qs[step];
      var pct = Math.round((step / qs.length) * 100);
      shell.appendChild(el('div', { class: 'pw-quiz__top' }, [
        el('span', { text: 'Find your water system' }),
        el('span', { text: 'Question ' + (step + 1) + ' of ' + qs.length, 'aria-live': 'polite' })
      ]));
      var bar = el('div', { class: 'pw-quiz__bar', role: 'progressbar', 'aria-valuemin': '0', 'aria-valuemax': '100', 'aria-valuenow': String(pct), 'aria-label': 'Quiz progress' }, [el('i')]);
      bar.firstChild.style.width = pct + '%';
      shell.appendChild(bar);

      var body = el('div', { class: 'pw-quiz__body' });
      var fs = el('fieldset');
      var legend = el('legend', { text: q.title, tabindex: '-1', id: uid + '-legend' });
      fs.appendChild(legend);
      if (q.help) fs.appendChild(el('p', { class: 'pw-quiz__help', text: q.help }));

      var opts = q.options.filter(function (o) { return !o.only || o.only.indexOf(answers.source) > -1 || !answers.source; });
      var grid = el('div', { class: 'pw-quiz__opts' + (opts.length <= 3 || q.id === 'hardness' ? ' pw-quiz__opts--one' : '') });
      var cur = answers[q.id];

      opts.forEach(function (o, i) {
        var id = uid + '-' + q.id + '-' + i;
        var input = el('input', { type: q.type === 'many' ? 'checkbox' : 'radio', name: uid + '-' + q.id, id: id, value: o.v });
        var checked = q.type === 'many' ? (cur || []).indexOf(o.v) > -1 : cur === o.v;
        if (checked) input.checked = true;
        input.addEventListener('change', function () {
          if (q.type === 'many') {
            answers[q.id] = Array.prototype.map.call(grid.querySelectorAll('input:checked'), function (n) { return n.value; });
          } else {
            answers[q.id] = o.v;
          }
          next.disabled = !canAdvance(q);
        });
        var label = el('label', { class: 'pw-opt' + (q.type === 'many' ? ' pw-opt--multi' : ''), for: id }, [
          input,
          el('span', {}, [document.createTextNode(o.t), o.s ? el('small', { text: o.s }) : null])
        ]);
        grid.appendChild(label);
      });
      fs.appendChild(grid);
      body.appendChild(fs);

      var nav = el('div', { class: 'pw-quiz__nav' });
      var back = el('button', { type: 'button', class: 'pw-btn pw-btn--ghost', text: 'Back' });
      back.style.color = 'var(--pw-navy)';
      if (step === 0) back.style.visibility = 'hidden';
      back.addEventListener('click', function () { step = Math.max(0, step - 1); render(true); });
      var next = el('button', { type: 'button', class: 'pw-btn pw-btn--primary', text: step === qs.length - 1 ? 'See my results' : 'Continue' });
      next.disabled = !canAdvance(q);
      next.addEventListener('click', function () {
        if (q.id === 'source' && answers.concerns) {
          var allowed = QUESTIONS[1].options.filter(function (o) { return !o.only || o.only.indexOf(answers.source) > -1; }).map(function (o) { return o.v; });
          answers.concerns = answers.concerns.filter(function (v) { return allowed.indexOf(v) > -1; });
        }
        step += 1; render(true);
      });
      nav.appendChild(back); nav.appendChild(next);
      body.appendChild(nav);
      body.appendChild(el('p', { class: 'pw-quiz__fine', text: 'Your answers stay in this browser tab. Nothing is sent or stored.' }));
      shell.appendChild(body);
      root.appendChild(shell);
      if (focus) legend.focus({ preventScroll: false });
    }

    function canAdvance(q) {
      var v = answers[q.id];
      if (q.type === 'many') return true; // choosing none is allowed
      return !!v;
    }

    function renderResult(shell) {
      var out = recommend(answers, urls);
      shell.appendChild(el('div', { class: 'pw-quiz__top' }, [el('span', { text: 'Your results' }), el('span', { text: 'Based on ' + visible().length + ' answers' })]));
      var bar = el('div', { class: 'pw-quiz__bar', role: 'presentation' }, [el('i')]);
      bar.firstChild.style.width = '100%';
      shell.appendChild(bar);

      var body = el('div', { class: 'pw-quiz__body' });
      var res = el('div', { class: 'pw-result' });
      var h = el('h2', { class: 'pw-h3', text: 'Here is where we would start', tabindex: '-1', id: uid + '-result' });
      res.appendChild(h);

      var chips = el('div', { class: 'pw-result__chips' });
      var tags = [LABELS[answers.source]]
        .concat((answers.concerns || []).map(function (c) { return LABELS[c]; }))
        .concat([answers.hardness === 'hard' ? LABELS.hardlvl : LABELS[answers.hardness], LABELS[answers.baths]]);
      tags.filter(Boolean).forEach(function (t) { chips.appendChild(el('span', { class: 'pw-chip', text: t })); });
      res.appendChild(chips);

      out.recs.forEach(function (r) {
        var card = el('div', { class: 'pw-rec' + (r.main ? ' pw-rec--main' : '') }, [
          el('div', { class: 'pw-rec__body' }, [
            el('div', { class: 'pw-rec__label', text: r.main ? 'Best starting point' : 'Also consider' }),
            el('h3', { text: r.title }),
            el('p', { text: r.why })
          ]),
          el('a', { class: 'pw-btn ' + (r.main ? 'pw-btn--primary' : 'pw-btn--ghost'), href: r.url, text: r.cta, style: r.main ? '' : 'color:var(--pw-navy)' })
        ]);
        res.appendChild(card);
      });

      res.appendChild(el('p', { class: 'pw-result__note', text: out.note }));
      var again = el('button', { type: 'button', class: 'pw-btn pw-btn--ghost', text: 'Start over', style: 'color:var(--pw-navy);align-self:flex-start' });
      again.addEventListener('click', function () { answers = {}; step = 0; render(true); });
      var row = el('div', { class: 'pw-actions' }, [again, el('a', { class: 'pw-btn pw-btn--ghost', href: urls.contact, text: 'Ask a question', style: 'color:var(--pw-navy)' })]);
      res.appendChild(row);
      body.appendChild(res);
      shell.appendChild(body);
      setTimeout(function () { var r = document.getElementById(uid + '-result'); if (r) r.focus(); }, 0);
    }

    render(false);
  });
})();
